import type { DuelModule } from "./types";

/**
 * In-memory registry of duels (ADR 0076), apart from games and puzzle types. The core only
 * talks to a duel through this module: never import `src/duels/<duel>/**` from `src/core`.
 */
const registry = new Map<string, DuelModule>();

export function registerDuel(module: DuelModule): void {
  if (registry.has(module.key)) throw new Error(`duel "${module.key}" is already registered`);
  registry.set(module.key, module);
}

export function getDuel(key: string): DuelModule | undefined {
  return registry.get(key);
}

/** Every duel this build ships, in registration order. */
export function allDuels(): DuelModule[] {
  return [...registry.values()];
}

export type {
  DuelBoardProps,
  DuelFrame,
  DuelLog,
  DuelModule,
  RealtimeBoardProps,
  RealtimeHandle,
  Side,
} from "./types";
